export enum DocumentSigningDashboardPermissions {
    View = "Permissions.DocumentSigning.View",
    CreateSigning = "Permissions.DocumentSigning.CreateSigning"
}